import { render, staticRenderFns } from "./MemoryIQView.vue?vue&type=template&id=65d64398&scoped=true&"
import script from "./MemoryIQView.vue?vue&type=script&lang=js&"
export * from "./MemoryIQView.vue?vue&type=script&lang=js&"
import style0 from "./MemoryIQView.vue?vue&type=style&index=0&id=65d64398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d64398",
  null
  
)

/* custom blocks */
import block0 from "./MemoryIQView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports